import { object, number, string } from 'yup';
import {
  ID_PERCENT_SALDO,
  ID_TEMPORARIO,
  ID_VITALICIO,
  ID_CONJUGADO,
} from '../../../pages/Beneficios/components/Renda/utils';

export const rendaSchema = (usuarioTaesa) => {
  return object({
    tipoRendaMensal: string().required('O tipo de renda mensal é obrigatório'),
    mesesAposentar: number()
      .integer()
      .required('Os anos para aposentar é obrigatório')
      .min(0),
    crescimentoSalario: string().when('mesesAposentar', {
      is: (value) => value > 0,
      then: (field) => field.required('O crescimento de salário é obrigatório'),
    }),
    remuneracaoMensal: number().when('mesesAposentar', {
      is: (value) => value > 0,
      then: (field) => field.required('A remuneração mensal é obrigatória'),
    }),

    remuneracoesAno: usuarioTaesa
      ? string().optional()
      : string().when('mesesAposentar', {
          is: (value) => value > 0,
          then: (field) =>
            field.required('O campo de remunerações no ano é obrigatório'),
        }),
    retornoInvestimento: string().when('mesesAposentar', {
      is: (value) => value > 0,
      then: (field) =>
        field.required('O retorno de investimento é obrigatório'),
    }),
    percentualSaque: string().required('O percentual de saque é obrigatório'),
    percentualSaldoVitalicio: number().when('tipoRendaMensal', {
      is: ID_CONJUGADO,
      then: (field) =>
        field
          .required()
          .min(50, 'Valor mínimo: 50%')
          .max(99, 'Valor máximo: 99%'),
    }),
    percentualContribuicao: string().when('mesesAposentar', {
      is: (value) => value > 0,
      then: (field) =>
        field.required('O percentual de contribuição é obrigatório'),
    }),
    percentualrcm: number().when('tipoRendaMensal', {
      is: (value) => value === ID_VITALICIO || value === ID_CONJUGADO,
      then: (field) =>
        field
          .required()
          .integer('O valor precisa ser inteiro')
          .min(0, 'Valor mínimo: 0%')
          .max(100, 'Valor máximo: 100%'),
    }),
    prazoRendaTemporaria: number().when('tipoRendaMensal', {
      is: ID_TEMPORARIO,
      then: (field) => field.required(),
    }),
    percentualRendaMensal: number().when('tipoRendaMensal', {
      is: (value) => value === ID_PERCENT_SALDO || value === ID_CONJUGADO,
      then: (field) => {
        if (localStorage.getItem('Plano') === '1') {
          return field
            .required()
            .float(2, 'Máximo de duas casas decimais após o ponto')
            .min(0.1, 'Valor mínimo: 0,10%')
            .max(1, 'Valor máximo: 1,00%');
        }
        if (localStorage.getItem('Plano') === '2') {
          return field
            .required()
            .float(2, 'Máximo de duas casas decimais após o ponto')
            .min(0.1, 'Valor mínimo: 0,10%')
            .max(1, 'Valor máximo: 1,00%');
        }
        return field
          .required()
          .float(2, 'Máximo de duas casas decimais após o ponto')
          .min(0.5, 'Valor mínimo: 0,50%')
          .max(1, 'Valor máximo: 1,00%');
      },
    }),
  });
};

export class RendaModel {
  tipoRendaMensal = '';

  percentualRendaMensal = 0;

  mesesAposentar = 0;

  percentualContribuicao = 0;

  remuneracaoMensal = 0;

  crescimentoSalario = 0;

  remuneracoesAno = 0;

  retornoInvestimento = 0;

  percentualSaque = 0;

  prazoRendaTemporaria = 0;

  percentualrcm = 0;

  percentualSaldoVitalicio = 0;

  beneficiariosChecked = [];
}
